<template>
  <header class="w-full max-display flex justify-center" >
    <header-logo-svg @showStartScreen="$emit('showStartScreen')" class="cursor-pointer" :logoColour="colourLogo"/>
  </header>
</template>
<script>
import HeaderLogoSvg from "@/components/Header/HeaderLogoSvg";
export default {
  name: 'XHeader',
  components:{
    HeaderLogoSvg
  },
  props: {
    changeColour: {
      type: Boolean,
    },
  },
  computed: {
    colourLogo() {
      return this.changeColour ? '#ffffff' : '#20262d';
    }
  },
}
</script>